// @flow
// This file is generated by make-version-metadata.js script
// Don't import this file directly, prefer to use newIDE/app/src/Version/index.js instead.
// prettier-ignore
module.exports = {
  "version": "5.6.257",
  "gitHash": "unknown-hash",
  "versionWithHash": "5.6.257-unknown-hash"
};
